import {
  ActivitiesSection,
  Cover,
  Header,
  Main,
  Promos,
  ScoreGraph,
  ServicesCards
} from 'components';
import React, { useEffect, useState } from 'react';
import { activities, graphs, promos, services } from 'static';
import { ActivitiesData, CoverData, GraphData, PromosData, ServicesData } from 'types';

import { Section } from './styles';

export const HomeHealth: React.FC = () => {
  const [graph, setGraph] = useState<GraphData>({} as GraphData);
  const [healthServices, setHealthServices] = useState<ServicesData[]>([] as ServicesData[]);
  const [healthPromos, setHealthPromos] = useState<PromosData[]>([] as PromosData[]);
  const [coverContent, setCoverContent] = useState<CoverData>({} as CoverData);
  const [activitiesContent, setActivitiesContent] = useState<ActivitiesData[]>(
    [] as ActivitiesData[]
  );

  useEffect(() => {
    setHealthServices(services.filter(({ area, card }) => area === 'saúde' && card.show));
    setHealthPromos(promos.filter(({ area }) => area === 'saúde'));
    setActivitiesContent(activities.filter(({ area }) => area === 'saúde'));
    setCoverContent(
      services.filter(({ slug }) => slug === '/saude/inicio').shift()?.cover || ({} as CoverData)
    );
  }, []);

  useEffect(() => {
    const currentGraph = graphs.filter(({ area }) => area === 'saúde').shift();
    if (currentGraph) setGraph(currentGraph);
  }, []);

  return (
    <>
      <Header />
      <Main>
        <Cover {...coverContent} />
        <Promos promos={healthPromos} />
        <Section>
          <div className="intro">
            <h2>Pontos</h2>
            <p>Conquista objetivos e ganha pontos!</p>
          </div>
          {graph.area && <ScoreGraph graph={graph} card_size="md" />}
        </Section>
        <ActivitiesSection activities={activitiesContent} />
        <ServicesCards
          services={healthServices}
          title="A pensar em si"
          description="Selecione um serviço e prepare-se para conquistar mais pontos"
        />
      </Main>
    </>
  );
};
